import React from 'react'
import { IconsProps } from 'msp-integrations'

const DropEmptyIcon = (props: IconsProps) => {
  return (
    <svg
      width='19'
      height='23'
      viewBox='0 0 19 23'
      {...props}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d="M9.304 22.384C4.174 22.384 0 18.21 0 13.08 0 6.443 8.023 0 9.304 0c1.281 0 9.305 6.443 9.305 13.08 0 5.13-4.175 9.304-9.305 9.304ZM9.3.81C8.385.893.809 6.861.809 13.08c0 4.685 3.81 8.495 8.495 8.495 4.685 0 8.496-3.81 8.496-8.495C17.8 6.86 10.224.893 9.299.81Z" />
    </svg>
  )
}

export default DropEmptyIcon
